import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import './index.css';
import ReactDOM from 'react-dom/client';
import { StrictMode } from 'react';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './modules/store';
import App from './App';

// HashRouter is intentional to support static hosting (e.g. IPFS) without server-side rewrites.
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}
const root = ReactDOM.createRoot(rootElement);
root.render(
  <StrictMode>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </StrictMode>
);
